module.exports = __webpack_public_path__ + "img/CPTemp10.be1a4e53.png";